import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'tours-and-experiences-tour-list',
  templateUrl: './tours-and-experiences-tour-list.component.html',
  styleUrls: ['./tours-and-experiences-tour-list.component.scss'],
})
export class ToursAndExperiencesTourListComponent implements OnInit {
  @Input() attractions: any;
  @Input() travellerCount: { adult: number; children: number; infant: number };
  @Input() attractionLength: number;
  @Output() handleSelectedAttraction = new EventEmitter<any>();
  currencyCode: any;
  selectedTime: any;
  selectedAttraction: any;
  totalPrice: any;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.currencyCode = this.attractions?.currency;
    this.selectedAttraction = this.attractions?.locations?.[0];
    this.selectedTime = {
      index: 0,
      time: this.selectedAttraction?.timeSlots?.[0],
    };
    this.totalPrice =
      this.selectedAttraction?.infantPrice * this.travellerCount.infant +
      this.selectedAttraction?.childPrice * this.travellerCount.children +
      this.selectedAttraction?.adultPrice * this.travellerCount.adult;
    this.handleSelectedAttraction.emit({
      attraction: this.selectedAttraction,
      time: this.selectedTime,
      totalPrice: this.totalPrice,
    });
  }

  handleSelectAttraction(event: any): void {
    this.selectedAttraction = event.target.value;
    this.selectedTime = {
      ...this.selectedTime,
      index: 0,
      time: this.selectedAttraction?.timeSlots?.[0],
      totalPrice: this.totalPrice,
    };
    this.analyticsService.trackUnified('attraction_selected', {
      flow: 'tours_and_experiences',
      outcome: 'success',
      legacy_event_name: 'radio_button_clicked',
      attraction: event.target.value,
      time: this.selectedTime.time,
    });
    this.totalPrice =
      this.selectedAttraction?.infantPrice * this.travellerCount.infant +
      this.selectedAttraction?.childPrice * this.travellerCount.children +
      this.selectedAttraction?.adultPrice * this.travellerCount.adult;
    this.handleSelectedAttraction.emit({
      attraction: this.selectedAttraction,
      time: this.selectedTime,
      totalPrice: this.totalPrice,
    });
  }

  handleSelectTime(index: number, time: string): void {
    this.selectedTime = { index, time };
    this.analyticsService.trackUnified('time_slot_selected', {
      flow: 'tours_and_experiences',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      attraction: this.selectedAttraction,
      time: this.selectedTime.time,
    });
    this.totalPrice =
      this.selectedAttraction?.infantPrice * this.travellerCount.infant +
      this.selectedAttraction?.childPrice * this.travellerCount.children +
      this.selectedAttraction?.adultPrice * this.travellerCount.adult;
    this.handleSelectedAttraction.emit({
      attraction: this.selectedAttraction,
      time: this.selectedTime,
      totalPrice: this.totalPrice,
    });
  }

  calculateTotalPrice(attraction: any) {
    return (
      attraction?.infantPrice * this.travellerCount.infant +
      attraction?.childPrice * this.travellerCount.children +
      attraction?.adultPrice * this.travellerCount.adult
    );
  }
}
